import axios from 'axios';

export const uploadFileToBucket = async (
  file: File,
  url: string
): Promise<void> => {
  await axios.put(url, file);
};
